import { WebcamImage } from 'ngx-webcam';

export class DocumentImage {
    image: WebcamImage;
}
